import React from "react";

import Testimonials from "../components/Testimonials";
import "./AboutUs.css";
import aboutImg from "../assets/about-classroom.jpg";

const AboutUs = () => {
  return (
    <>
      
      <div className="about-container">
        

        <div className="about-content">
          <div className="about-text">
            <div className="about-inner">
              <div className="about-image">
                <img src={aboutImg} alt="Classroom" />
              </div>
              <div className="about-details">
                <button className="about-btn">Get More About Us</button>
                <h1>Welcome To Codex Future</h1>
                <p>
                  At Codex Future, we believe in empowering individuals and organizations with the skills they need to thrive in an ever-evolving technological landscape. As a leading provider of IT training, we specialize in delivering comprehensive, future-focused courses designed to equip our clients with the knowledge and expertise required to excel in the digital age.
                </p>

                <h2>Our Mission</h2>
                <p>
                  Our mission is to bridge the gap between technology and human potential by offering innovative training solutions that drive success. We are dedicated to providing high-quality, hands-on training that prepares our clients for the challenges and opportunities of tomorrow. Whether you’re a professional seeking to upskill, a company looking to enhance your team’s capabilities, or an individual pursuing a new career path, Codex Future is here to guide you every step of the way.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Testimonials/>
    
    </>
  );
};

export default AboutUs;
